import React from 'react';
import style from './additionalInfo.module.scss';
import classNames from 'classnames';
import HelicopterIcon from 'acscp/assets/helicopter.svg';
import CarIcon from 'acscp/assets/car.svg';
import MeetIcon from 'acscp/assets/meet.svg';
import { FormattedMessage } from 'react-intl';
import { ItineraryAdditionalInformation } from 'acscp/store';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';
import { isEmpty } from 'acscp/components/common/helpers/isEmpty';
import { AdditionalItem } from './additionalItem';

const OptionalServicesContent: React.SFC<{additionalInformation: ItineraryAdditionalInformation}> =
    ({additionalInformation}) => {

    if (isEmpty(additionalInformation)) {
        return null;
    }

    return (
        <div className={classNames([style.Container, style.OptionalServices])}>
            <div className={style.InnerContainer}>
                <AdditionalItem
                    icon={HelicopterIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.optionalServices.helicopter'}
                        defaultMessage={'Helicopter Connection'}
                    />}
                >
                    {additionalInformation.helicopterConnection}
                </AdditionalItem>
                <AdditionalItem
                    icon={CarIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.optionalServices.groundTransportation'}
                        defaultMessage={'Ground Transportation'}
                    />}
                >
                    {additionalInformation.groundTransportation}
                </AdditionalItem>
                <AdditionalItem
                    icon={MeetIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.optionalServices.meetAndGreet'}
                        defaultMessage={'Meet and Greet Service'}
                    />}
                >
                    {additionalInformation.meetAndGreetService}
                </AdditionalItem>
            </div>
        </div>
    );
};

const OptionalServices = withCollapsable(
    (
        <Title>
            <FormattedMessage id={'web.components.itinerary.optionalServicesTitle'} defaultMessage={'OPTIONAL SERVICES'} />
        </Title>
    ),
    OptionalServicesContent);

export { OptionalServices };
